/**
 * import react
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui
 */
import TabelRow from '@material-ui/core/TableRow';
import TabelCell from '@material-ui/core/TableCell';
import CheckBox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
/**
 * import material icons
 */
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import Info from '@material-ui/icons/Info';
import makeStyles from '@material-ui/core/styles/makeStyles';

/**
 * import ui helper
 */
import { getCameraNvrRtspPref, getCameraAIRtspPref } from './helper';

/**
 * import components
 */
import AuthDialog from './auth-dialog';
import InfoDialog from './info-dialog';

/**
 * import const
 */
import { constVal } from '../slot-const';


const useStyles = makeStyles(() => ({
  root: {
    margin: 0
  },
  label: {
    fontSize: '1rem'
  }
}));

const SlotTableBodyRow = (props) => {
  const [infoDlg, setInfoDlg] = useState({ open: false });
  const [auth, setAuth] = useState({ open: false});
  const classes = useStyles();
  const { rIdx, slot = {} } = props;
  const { ipAddr = '', port = '', testedStatus = constVal.INITIAL, isDisabled = false, comment = '', macAddr = '' } = slot.ui;
  const status = (testedStatus === constVal.INITIAL) || (testedStatus === constVal.SUCCESS && !ipAddr) ? <FiberManualRecord />
    : ((testedStatus === constVal.SUCCESS ? <FiberManualRecord style={{ color: 'green' }}/> : <FiberManualRecord style={{ color: 'red' }}/>));
  let info = <Info />;
  if (testedStatus === constVal.SUCCESS) {
    if (getCameraAIRtspPref(slot)) {
      info = <Info style={{ color: 'green' }}/>;
    } else {
      info = <Info style={{ color: 'orange' }}/>;
    }
  } else if (testedStatus === constVal.FAILED) {
    info = <Info style={{ color: 'red' }} />;
  }
  // const info = (testedStatus === constVal.INITIAL) ? <Info />
  // : ((testedStatus === constVal.SUCCESS ? <Info style={{ color: 'green' }}/> : <Info style={{ color: 'red' }}/>));

  const handleRowSelectedOnClick = (e) => {
    const slotIdx = parseInt(e.currentTarget.getAttribute('slotIdx'));
    if (!isNaN(slotIdx)) {
      props.handleSlotListRowSelected(slotIdx);
    }
  };

  const handleInfoOnClick = () => {
    const handleClose = (pref) => {
      if (pref[0] !== getCameraNvrRtspPref(slot) || pref[1] !== getCameraAIRtspPref(slot)) {
        props.handleRtspPreferred(pref, rIdx);
      }
      setInfoDlg(() => ({ open: false }));
    };
    // const handleCancelOnClick = () => {
    //   setInfoDlg(() => false);
    //   // setMsgDialog(() => initialMsgDialogState);
    // };
    if (testedStatus === constVal.SUCCESS) {
      // const contentList = getCameraExtendedInfo(slot);
      // setMsgDialog(() => ({ open: true, type: constVal.MSG_TYPE_INFORMATION, title: 'Camera Info', contentList, handleCancelOnClick }));
      setInfoDlg(() => ({ open: true, slot, handleClose }));
    }
  };
  const handleTestOnClick = () => {
    setAuth(() => ({ 
      open: true, ipAddr, port, title: 'Please enter credential', userName: slot.cameraUserName, 
      password: slot.cameraPassword, comment: slot.cameraComment }));
  };

  const handleAuthDialogClose = (data) => {
    data = { ...data, macAddr, comment };
    if (slot.cameraUserName !== data.userName || slot.cameraPassword !== data.password) {
      props.handleTestedSlot({ data, slotIdx: rIdx });
    }
    setAuth(() => ({ open: false }));
  };

  const handleCommentOnChange = (e) => {
    const rIdx = parseInt(e.currentTarget.getAttribute('slotIdx'));
    if (!isNaN(rIdx)) {
      props.handleUpdateComment(rIdx, e.target.value);
    }
  };

  return (
    <>
      <TabelRow hover>
        <TabelCell>
          <FormControlLabel
            control={<CheckBox checked={props.isChecked} disabled={isDisabled} slotidx={rIdx} onClick={handleRowSelectedOnClick}/>}
            label={`#${rIdx + 1}`}
            labelPlacement="end"
            classes={{ label: classes.label}}
          />
        </TabelCell>
        <TabelCell style={{ textAlign: 'center' }}>
          {
            <List style={{ textAlign: 'center' }}>
              <ListItem key={0} style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'center' }}>
                <ListItemText style={{fontSize: '1rem'}} disableTypography>
                  {macAddr ? ipAddr ? `${ipAddr}:${port}` : 'Camera Not Found' : ''}
                </ListItemText>
              </ListItem>
              <ListItem key={1} style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'center' }}>
                <ListItemText style={{fontSize: '1rem'}} disableTypography>{macAddr}</ListItemText>
              </ListItem>
            </List>
          }
        </TabelCell>
        <TabelCell padding="none" style={{ textAlign: 'center' }}>
          <IconButton disabled={isDisabled || !ipAddr} slotidx={rIdx} onClick={handleTestOnClick}>{status}</IconButton>
        </TabelCell>
        <TabelCell padding="none" style={{ textAlign: 'center' }} onClick={handleInfoOnClick}>
          <IconButton disabled={isDisabled || !macAddr || (testedStatus !== constVal.SUCCESS)} >{info}</IconButton>
        </TabelCell>
        <TabelCell style={{ textAlign: 'center' }} slotidx={rIdx} onChange={handleCommentOnChange}>
          <TextField disabled={isDisabled || !macAddr} variant="outlined" value={comment} classes={{ root: classes.root}}></TextField>
        </TabelCell>
      </TabelRow>
      {infoDlg.open ? <InfoDialog {...infoDlg} /> : null}
      {auth.open ? <AuthDialog {...auth} handleAuthDialogClose={handleAuthDialogClose}/> : null}
    </>
  );
};

SlotTableBodyRow.propTypes = {
  rIdx: PropTypes.number.isRequired,
  slot: PropTypes.object.isRequired,
  isChecked: PropTypes.bool.isRequired,
  handleSlotListRowSelected: PropTypes.func.isRequired,
  handleUpdateComment: PropTypes.func.isRequired,
  handleRtspPreferred: PropTypes.func.isRequired
};

export default React.memo(SlotTableBodyRow);
